import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Http } from "@angular/http";
import { AlertController, LoadingController, ModalController } from "ionic-angular";
import { HomePage } from "../home/home";
import { ModalLivroCaixaPage } from '../modal-livro-caixa/modal-livro-caixa';


import config from "../../config/config";

/**
 * Generated class for the PerfilPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-perfil",
  templateUrl: "perfil.html"
})
export class PerfilPage {
  interesse = [
    { val: "Educação", isChecked: false },
    { val: "Cultura", isChecked: false },
    { val: "Lazer", isChecked: false },
    { val: "Violência contra mulher", isChecked: false },
    { val: "Combate ao racismo", isChecked: false },
    { val: "Política", isChecked: false },
    { val: "Ciencia e tecnologia", isChecked: false },
    { val: "Economia", isChecked: false },
    { val: "Esporte", isChecked: false },
    { val: "Saúde", isChecked: false },
    { val: "Segurança pública", isChecked: false },
    { val: "Direitos humanos", isChecked: false }
  ];
  verdadeiroFalso = [
    { val: true, label: "Sim" },
    { val: false, label: "Não" },
  ]

  parentesco = [
    { val: "Filho(a)" },
    { val: "Tutela" },
    { val: "cônjuge" },
    { val: "Filho(a) - PCD" }
  ]
  storage = 'https://backend.homologacao.sintufrj.org.br/storage/app/';
  bemVindo: any;
  usuario: any;
  form: any = {};
  dados: any = {};
  dependentes: any;
  foto = null;
  file = null;
  banco: any = {};
  jornal = false;
  pensionista: boolean;
  cpfValido: boolean;
  administrador: any;
  operador: boolean;
  descon: any;
  grupo: any;
  usuarioIdAuditoria: any;
  Localizacao: any;
  eFuncionario: boolean;
  aut: boolean;
  valicompro: boolean;
  orgaoList: { codigo: string; label: string; }[];
  checagemDeFoto: boolean;
  bancos: any;
  LocalizacaoUFRJ: any;
  fileDependente: File;
  erroArquivoDependente: boolean = false;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public modalCtrl: ModalController

  ) { }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.bemVindo = this.navParams.get("bemvindo");
    this.grupo = this.navParams.get("grupo");
    this.usuarioIdAuditoria = this.navParams.get("usuarioIdAuditoria");
    // this.getCodigos();
    this.dados = this.usuario.dados;
    this.administrador = this.navParams.get("adm");
    if (this.usuario.grupold == 2 || this.administrador == true) {
      this.administrador = true;
    }
    if (this.usuario.cpf != null) {
      this.cpfValido = true;
    }
    if (
      this.grupo == 2 ||
      this.grupo == 3 ||
      this.usuario.grupold == 2 ||
      this.administrador == true
    ) {
      this.operador = true;
      this.cpfValido = true;
    }

    this.dependentes = this.navParams.get("dependentes");
    this.form = this.usuario;
    if (this.navParams.get("usuario").agencia != null) {
      this.banco.banco = this.navParams.get("usuario").agencia.bancoId;
      this.banco.agencia = this.navParams.get("usuario").agencia.agencia;
      this.banco.conta = this.navParams.get("usuario").agencia.conta;
    }
    if (this.navParams.get("dados") != null) {
      this.dados = this.navParams.get("dados");
    }
    if (this.dados.foto == null) {
      this.dados.foto = "public/perfildefault.jpg";
    }
    if (
      this.dados.interesse == null ||
      !this.dados.interesse ||
      this.dados.interesse == undefined
    ) {
      this.dados.interesse = "";
    } else {
      this.interesse = JSON.parse(this.dados.interesse);
    }
    if (this.dados.LocalizacaoUfrj != null) {
      if (
        this.navParams.get("dados").LocalizacaoUfrj.substr(0, 1) == "8" ||
        this.navParams.get("dados").LocalizacaoUfrj.substr(0, 1) == "9"
      ) {
        this.jornal = true;
      }
      this.jornal = true;
      if (this.navParams.get("dados").LocalizacaoUfrj.substr(0, 1) == "8") {
        this.pensionista = true;
      } else {
        this.pensionista = false;
      }
    }
    if (this.dados.descontoEmFolha == null) {
      this.descon = false;
    } else if (
      this.dados.descontoEmFolha != null &&
      this.cpfValido &&
      this.dados.comprometo != null
    ) {
      this.descon = true;
    } else {
      this.descon = false;
    }

    if (this.usuario.grupold == 2 || this.usuario.grupold == 3) {
      this.descon = true;
    }

    if (this.dados.foto != null) {
      this.foto = this.dados.foto;
    }

    if (this.dados.telefonePessoal) {
      this.checkTelefone1(this.dados.telefonePessoal);
    }
    if (this.dados.telefoneResidencia) {
      this.checkTelefone2(this.dados.telefoneResidencia);
    }
    if (this.dados.telefoneTrabalho) {
      this.checkTelefone3(this.dados.telefoneTrabalho);
    }
    this.diminuirFuncionario()
    this.getLocalizacao();
    this.buscarBancos();

  }

  checkTelefone1(data) {
    let numero: any;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.dados.telefonePessoal = numero;
    }
  }
  checkTelefone2(data) {
    let numero: any;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.dados.telefoneResidencia = numero;
    }
  }
  checkTelefone3(data) {
    let numero: any;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.dados.telefoneTrabalho = numero;
    }
  }
  buscaPorCep() {
    let cep = this.dados.cep;
    cep = cep.replace(/-/g, "");
    if (cep.length == 8) {
      this._http
        .get("https://viacep.com.br/ws/" + cep + "/json/", {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          let logradouro = res.logradouro.split(" ");
          let tipo = logradouro[0];
          let rua = "";
          for (let f = 1; f < logradouro.length; f++) {
            rua += logradouro[f] + " ";
          }

          this.dados.estado = res.uf;
          this.dados.cidade = res.localidade;
          this.dados.bairro = res.bairro;
          this.dados.rua = rua;
          this.dados.tipodeEndereco = tipo;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
  checkFotos() {

    if (this.dados.foto.includes('public/perfildefault.jpg')) {
      this.checagemDeFoto = false;
    } else {
      this.checagemDeFoto = true;
    }
  }
  validador(form, dados, banco) {
    this.checkFotos();
    if (dados.comprometo && dados.descontoEmFolha && this.cpfValido && this.checagemDeFoto || this.operador) {
      this.alterarusua(form, dados, banco);


    } else {
      let alert = this.alertCtrl.create({
        title: "Obrigatórios",
        subTitle: "Os campos de autorização de desconto em folha, atualização de informações e Foto são obrigatorios",
        buttons: [
          {
            text: "OK",
            handler: data => { }
          }
        ]
      });
      alert.present();
    }
  }
  alterarusua(form, dados, banco) {
    this.dependadio();

    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    if (banco.conta) {
      if (banco.conta.length < 10) {
        let tam = 10 - banco.conta.length;
        let conta = "";
        for (let g = 0; g < tam; g++) {
          conta += "0";
        }
        banco.conta = conta + banco.conta;
      }
    }

    form.banco = banco.banco;
    form.agencia = banco.agencia;
    form.conta = banco.conta;
    form.usuarioIdAuditoria = this.usuarioIdAuditoria;

    dados.interesse = JSON.stringify(this.interesse);
    if (this.file != null) {
      dados.foto = "/" + this.foto;
    }
    dados.usuariold = form.id;
    let confe = false;
    if (dados.LocalizacaoUfrj) {
      if (dados.LocalizacaoUfrj != '' && this.usuario.grupold != 2 && this.usuario.grupold != 3) {

        if (dados.LocalizacaoUfrj.substr(0, 1) == "8") {
          confe = true;
        }
      }

    }

    if (confe) {

      if (
        dados.inscpf == null &&
        dados.insiape == null &&
        dados.insnome == null &&
        dados.insufrj == null
      ) {
        let alert = this.alertCtrl.create({
          title: "Alteração",
          subTitle:
            "Para ser pensionista é necessario informar os campos do instituidor",
          buttons: [
            {
              text: "ok",
              handler: data => {
                loading.dismiss();
              }
            }
          ]
        });
        alert.present();
      } else {
        confe = false;

        // console.log(form);

        this._http
          .post(config.urlAPI + "usuario/alterar", form, {})
          .map(res => res.json())
          .toPromise()
          .then(res => {
            this.form = res;
            // console.log(this.form);
            let dado = dados;
            this._http
              .post(config.urlAPI + "usuario/dados", dado, {})
              .map(res => res.json())
              .toPromise()
              .then(res => {

                loading.dismiss();
                this.dados = res;
                let alert = this.alertCtrl.create({
                  title: "Alteração",
                  subTitle: "realizada com sucesso",
                  buttons: [
                    {
                      text: "Voltar para Home",
                      handler: data => {
                        this.navCtrl.setRoot(HomePage);
                      }
                    },
                    {
                      text: "Continuar no perfil",
                      handler: data => { }
                    }
                  ]
                });
                alert.present();
              })
              .catch(error => {
                loading.dismiss();

                console.log(error);
              });
          })
          .catch(error => {
            loading.dismiss();

            console.log(error);
          });

      }
    } else {
      this._http
        .post(config.urlAPI + "usuario/alterar", form, {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          this.form = res;
          // console.log(res);
          let dado = dados;
          this._http
            .post(config.urlAPI + "usuario/dados", dado, {})
            .map(res => res.json())
            .toPromise()
            .then(res => {

              loading.dismiss();
              this.dados = res;
              let alert = this.alertCtrl.create({
                title: "Alteração",
                subTitle: "realizada com sucesso",
                buttons: [
                  {
                    text: "Voltar para Home",
                    handler: data => {
                      this.navCtrl.setRoot(HomePage);
                    }
                  },
                  {
                    text: "Continuar no perfil",
                    handler: data => { }
                  }
                ]
              });
              alert.present();
            })
            .catch(error => {
              loading.dismiss();

              console.log(error);
            });
        })
        .catch(error => {
          loading.dismiss();

          console.log(error);
        });
    }
  }
  arquivo(event) {
    this.file = <File>event.target.files[0];
    this.subirImage();
  }
  arquivoDependente(event, dependente) {

    const arquivo = event.target.files[0];
    this.erroArquivoDependente = false; // resetar erro

    if (!arquivo) {
      return;
    }

    const tipoValido = ['image/jpeg', 'image/png'];
    if (tipoValido.indexOf(arquivo.type) === -1) {
      this.erroArquivoDependente = true;
      event.target.value = ''; // limpa o input
      return;
    }
    dependente.subirfile = <File>event.target.files[0];
    this.erroArquivoDependente = false; // resetar erro
  }
  baixarDocumento(url) {
    window.open(this.storage + url)

  }
  subirImageDepentede(dependente) {
    let imagem = dependente.subirfile;
    const fd = new FormData();
    fd.append("image", imagem, imagem.name);
    this._http
      .post(config.urlAPI + "dependente/foto/" + dependente.id, fd, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error);
      });
  }
  subirImage() {
    let imagem = this.file;
    const fd = new FormData();
    fd.append("image", imagem, imagem.name);
    this._http
      .post(config.urlAPI + "perfil/foto", fd, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.foto = res;
        this.dados.foto = res;
      })
      .catch(error => {
        console.log(error);
      });
  }
  excluirusu() {
    let alert = this.alertCtrl.create({
      title: "Excluir",
      subTitle: "Tem certeza que deseja excluir o sindicalizado ?",
      buttons: [
        {
          text: "Sim",
          handler: data => {
            let env = {
              usuario: this.usuarioIdAuditoria,
              userAlvo: this.usuario.id
            }
            this._http
              .post(config.urlAPI + "delete/usuario", env, {})
              .map(res => res.json())
              .toPromise()
              .then(res => {
                let alert = this.alertCtrl.create({
                  title: "Alteração",
                  subTitle: "realizada com sucesso",
                  buttons: [
                    {
                      text: "Voltar para Home",
                      handler: data => {
                        this.navCtrl.setRoot(HomePage);
                      }
                    }
                  ]
                });
                alert.present();
              })
              .catch(error => {
                console.log(error);
              });
          }
        },
        {
          text: "Não",
          handler: data => { }
        }
      ]
    });
    alert.present();
  }
  autorizo(env) {
    if (this.cpfValido == true && env == true && this.valicompro) {
      this.descon = env;
      this.aut = true;
    } else {
      this.descon = false;
      this.aut = false;


    }

    if (this.usuario.grupold == 2 || this.usuario.grupold == 3) {
      this.descon = true;
    }
  }
  compro(env) {
    if (this.cpfValido && this.aut && env) {
      this.descon = true;
      this.valicompro = true;
    } else {
      this.descon = false;
      this.valicompro = false;

    }
  }

  resultadoCPF(cpf) {
    let resultado = false;
    if (cpf.length == 11) {
      let valido = this.TestaCPF(cpf);
      resultado = valido;
      if (
        this.usuario.dados.descontoEmFolha == 1 &&
        this.usuario.dados.comprometo != false
      ) {
        this.descon = true;
      }
      if (!resultado) {
        let alert = this.alertCtrl.create({
          title: "CPF",
          subTitle: "CPF invalido",
          buttons: [
            {
              text: "colocar outro",
              handler: data => { }
            }
          ]
        });
        alert.present();
      }
    } else {
      this.descon = false;
      this.cpfValido = false;
    }

    if (resultado) {
      this.cpfValido = true;
    } else {
      this.cpfValido = false;
      this.descon = false;

    }
  }
  TestaCPF(cpf) {
    cpf = cpf.replace(/\D/g, "");
    if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var result = true;
    [9, 10].forEach(function (j) {
      var soma = 0,
        r;
      cpf
        .split(/(?=)/)
        .splice(0, j)
        .forEach(function (e, i) {
          soma += parseInt(e) * (j + 2 - (i + 1));
        });
      r = soma % 11;
      r = r < 2 ? 0 : 11 - r;
      if (r != cpf.substring(j, j + 1)) result = false;
    });
    return result;
  }
  adidep() {
    let dependente = {
      id: 0,
      nome: "",
      registro: this.form.registro,
      parentesco: "",
      nascimento: ""
    };
    this.dependentes.push(dependente);
  }
  removeDep(element) {
    if (element.id != 0) {
      let alert = this.alertCtrl.create({
        title: "Excluir",
        subTitle: "Deseja realmente excluir o dependente",
        buttons: [
          {
            text: "Sim",
            handler: data => {
              const index = this.dependentes.indexOf(element);
              this.dependentes.splice(index, 1);
              this._http
                .get(config.urlAPI + "delete/dependente/" + element.id, {})
                .map(res => res.json())
                .toPromise()
                .then(res => { })
                .catch(error => {
                  console.log(error);
                });
            }
          },
          {
            text: "Não",
            handler: data => { }
          }
        ]
      });
      alert.present();
    } else {
      const index = this.dependentes.indexOf(element);
      this.dependentes.splice(index, 1);
    }
  }
  dependadio() {
    let alterar = [];
    let salvar = [];
    if (this.dependentes) {
      for (const element of this.dependentes) {
        element;
        if (element.id != 0) {
          alterar.push(element);
          if (element.subirfile) {
            this.subirImageDepentede(element)
          }

        } else {
          if (
            element.nome == "" ||
            element.parentesco != "" ||
            element.dataNascimento != "" ||
            element.comprobatorio != ""
          ) {
            salvar.push(element);
          }
        }
      }
    }

    if (salvar.length > 0) {
      let salvarenv = JSON.stringify(salvar);
      let env = { env: salvarenv };
      this.novoDepen(env);
    }
    if (alterar.length > 0) {
      let alterarenv = JSON.stringify(alterar);
      let env = { env: alterarenv };
      this.alterarDen(env);
    }
  }
  alterarDen(env) {
    this._http
      .post(config.urlAPI + "alterar/dependente", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => { })
      .catch(error => {
        console.log(error);
      });
  }

  novoDepen(env) {
    this._http
      .post(config.urlAPI + "novo/dependente", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this._http
          .get(config.urlAPI + "pegar/dependentes/" + this.usuario.registro, {})
          .map(res => res.json())
          .toPromise()
          .then(res => {
            this.dependentes = res;
            console.log(res);


          })
          .catch(error => {
            console.log(error);
          });
      })
      .catch(error => {
        console.log(error);
      });
  } // < - aqui


  diminuirFuncionario() {
    if (this.usuario.grupold == 3) {
      this.eFuncionario = true;
      this.dependentes = null;
    } else if (this.usuario.grupold == 2) {
      this.eFuncionario = true;
      this.dependentes = null;
    } else if (this.usuario.grupold == 4) {
      this.eFuncionario = true;
      this.dependentes = null;
    }
    else {
      this.eFuncionario = false;

    }
  }



  getItems(ev) {
    const val = ev;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.Localizacao = this.Localizacao.filter((item) => {

        return (item.unidade.toString().toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    } else {
      this.getCodigos();
    }
    // console.log(this.items);
  }

  add(item) {
    // this.dados.LocalizacaoUfrj=item;
    this.dados.LocalizacaoUfrj = item.codigo_local;
    this.dados.unidade = item.unidade;



  }

  getItems2(ev) {
    this.getOrgao();
    const val = ev;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.orgaoList = this.orgaoList.filter((item) => {
        return (item.label.toString().toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    } else {
      this.getOrgao();
    }
    // console.log(this.items);
  }

  add2(item) {
    this.dados.sisapnet = item.codigo;
    // this.dados.unidade=item.label;
    // console.log(this.dados.LocalizacaoUfrj); 
    if (item == "99999999") {
      this.jornal = true;
    } else {
      this.jornal = false;
    }

    if (item.substring(0, 3) == "888") {
      this.pensionista = true;
    } else {
      this.pensionista = false;
    }


  }
  getLocalizacao() {
    this._http
      .get(config.urlAPI + "pesquisar/localizacao", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.LocalizacaoUFRJ = res;
        this.getCodigos()

      }).catch(err => {
        console.log(err)

      })
  }
  getCodigos() {
    this.Localizacao = this.LocalizacaoUFRJ;
  }

  getOrgao() {
    this.orgaoList =
      [
        { codigo: "13000", label: "MINIST.DA AGRICULTURA,PECUARIA E ABAST. " },
        { codigo: "14000", label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: "15000", label: "MINISTERIO DA EDUCACAO " },
        { codigo: "16000", label: "COMANDO DO EXERCITO " },
        { codigo: "16100", label: "FUNDACAO OSORIO " },
        { codigo: "17000", label: "MINISTERIO DA ECONOMIA " },
        { codigo: "17201", label: "SUPERINTENDENCIA NAC. DE ABASTECIMENTO " },
        { codigo: "20000", label: "MINIST. DA JUSTI¸A E SEGURAN¸A PUBLICA " },
        { codigo: "20101", label: "PRESIDENCIA DA REPUBLICA " },
        { codigo: "20102", label: "VICE-PRESIDENCIA DA REPUBLICA " },
        { codigo: "20104", label: "SECRETARIA DE ASSUNTOS ESTRATEGICOS / P " },
        { codigo: "20112", label: "SECRETARIA DE PROJETOS ESPECIAIS - PR " },
        { codigo: "20113", label: "MINISTERIO DO PLANEJ. DESENV. E GESTAO " },
        { codigo: "20114", label: "AGENCIA BRASILEIRA DE INTELIGENCIA " },
        { codigo: "20115", label: "DEPARTAMENTO DE POLICIA FEDERAL " },
        { codigo: "20125", label: "CONTROLADORIA-GERAL DA UNIAO " },
        { codigo: "20224", label: "AGENCIA NACIONAL DO CINEMA " },
        { codigo: "20302", label: "NUCLEBRAS EQUIPAMENTOS PESADOS " },
        { codigo: "20304", label: "INDUSTRIAS NUCLEARES DO BRASIL " },
        { codigo: "20415", label: "EMPRESA BRASIL DE COMUNICACAO " },
        { codigo: "20605", label: "COMPANHIA DE DESENVOLV. DE BARCAREMA " },
        { codigo: "21000", label: "COMANDO DA AERONAUTICA " },
        { codigo: "21201", label: "CAIXA DE FINANCIAMENTO IMOB.AERONAUTICA " },
        { codigo: "21300", label: "AGENCIA ESPACIAL BRASILEIRA " },
        { codigo: "22000", label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: "22107", label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: "22108", label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: "22109", label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: "22200", label: "COMPANHIA NACIONAL DE ABASTECIMENTO " },
        { codigo: "22202", label: "EMPRESA BRASILEIRA DE PESQ. AGROPECUARI " },
        { codigo: "22203", label: "COMPANHIA DESENV. DO VALE SAO FRANCISCO " },
        { codigo: "22207", label: "COMPANHIA DE COLONIZACAO DO NORDESTE " },
        { codigo: "23000", label: "MINISTERIO DA PREVIDENCIA SOCIAL " },
        { codigo: "24203", label: "FUNDACAO NACIONAL DE ARTES " },
        { codigo: "24204", label: "INSTITUTO DO PATR.HIST.E ART. NACIONAL " },
        { codigo: "24205", label: "FUNDACAO BIBLIOTECA NACIONAL " },
        { codigo: "24206", label: "FUNDACAO NACIONAL DE ARTES CENICAS " },
        { codigo: "24207", label: "FUNDACAO DO CINEMA BRASILEIRO " },
        { codigo: "24209", label: "CENTRO NAC.TECNO.ELETRONICA AVANCADA S. " },
        { codigo: "25000", label: "MINISTERIO DA SAUDE " },
        { codigo: "25207", label: "SERVICO FED. DE PROCESSAMENTO DE DADOS " },
        { codigo: "25801", label: "RECEITA FEDERAL DO BRASIL " },
        { codigo: "26000", label: "MINISTERIO DO TRABALHO E EMPREGO " },
        { codigo: "26104", label: "INSTITUTO NACIONAL DE EDUCACAO DE SURDO " },
        { codigo: "26105", label: "INSTITUTO BENJAMIN CONSTANT " },
        { codigo: "26106", label: "FUNDO NACIONAL DE DESENVOLV. DA EDUCACA " },
        { codigo: "26107", label: "INST.NACIONAL DE EST.E PESQ.EDUCACIONAI " },
        { codigo: "26201", label: "COLEGIO PEDRO II " },
        { codigo: "26202", label: "CENTRO FED DE EDUC TECNOL DE ALAGOAS " },
        { codigo: "26203", label: "CENTRO FED.EDUC. TECNOLOGICA DO AMAZONA " },
        { codigo: "26204", label: "CENTRO FED. DE EDUC. TECNOL. DA BAHIA " },
        { codigo: "26205", label: "CENTRO FED.DE EDUC.TECNOL. DE CAMPOS " },
        { codigo: "26206", label: "CENTRO FED.DE EDUC.TECNOL.DO CEARA " },
        { codigo: "26207", label: "CENTRO FED.DE EDUC.TECNOL.ESPIRITO SANT " },
        { codigo: "26208", label: "CENTRO FED.DE EDUC.TECNOL. DE GOIAS " },
        { codigo: "26209", label: "CENTRO FED. DE EDUC. TECNOL. DO MARANHA " },
        { codigo: "26210", label: "CENTRO FED DE EDUC TEC DE MATO GROSSO " },
        { codigo: "26211", label: "CENTRO FED.DE EDUC.TECNOL. DE OURO PRET " },
        { codigo: "26212", label: "CENTRO FED.DE EDUC.TECNOL.DO PARA " },
        { codigo: "26213", label: "CENTRO FED.DE EDUC.TECNOL.DA PARAIBA " },
        { codigo: "26214", label: "CENTRO FED.DE EDUC.TECNOL.DE PELOTAS " },
        { codigo: "26215", label: "CENTRO FED.DE EDUC.TECNOL. DE PERNAMBUC " },
        { codigo: "26216", label: "CENTRO FED.DE EDUC.TECNOL. DO PIAUI " },
        { codigo: "26217", label: "CEFET DE QUIMICA DE NILOPOLIS-RJ " },
        { codigo: "26218", label: "CENTRO FED.EDUC.TECNOL.DO R. G. DO NORT " },
        { codigo: "26219", label: "CENTRO FED EDUC TEC DE SANTA CATARINA " },
        { codigo: "26220", label: "CENTRO FED.DE EDUC.TECNOL.DE SAO PAULO " },
        { codigo: "26221", label: "CENTRO FEDERAL DE EDUC TEC DE SERGIPE " },
        { codigo: "26222", label: "CENTRO FED.DE EDUC.TECNOL. DE RORAIMA " },
        { codigo: "26223", label: "ESCOLA TECNICA FEDERAL DE PALMAS " },
        { codigo: "26227", label: "ESCOLA TECNICA FEDERAL DE RONDONIA " },
        { codigo: "26230", label: "FUND.UNIV.FED.DO VALE DO SAO FRANCISCO " },
        { codigo: "26231", label: "UNIVERSIDADE FEDERAL DE ALAGOAS " },
        { codigo: "26232", label: "UNIVERSIDADE FEDERAL DA BAHIA " },
        { codigo: "26233", label: "UNIVERSIDADE FEDERAL DO CEARA " },
        { codigo: "26234", label: "UNIVERSIDADE FEDERAL DO ESPIRITO SANTO " },
        { codigo: "26235", label: "UNIVERSIDADE FEDERAL DE GOIAS " },
        { codigo: "26236", label: "UNIVERSIDADE FEDERAL FLUMINENSE " },
        { codigo: "26237", label: "UNIVERSIDADE FEDERAL DE JUIZ DE FORA " },
        { codigo: "26238", label: "UNIVERSIDADE FEDERAL DE MINAS GERAIS " },
        { codigo: "26239", label: "UNIVERSIDADE FEDERAL DO PARA " },
        { codigo: "26240", label: "UNIVERSIDADE FEDERAL DA PARAIBA " },
        { codigo: "26241", label: "UNIVERSIDADE FEDERAL DO PARANA " },
        { codigo: "26242", label: "UNIVERSIDADE FEDERAL DE PERNAMBUCO " },
        { codigo: "26243", label: "UNIVERSIDADE FED. DO RIO GRANDE DO NORT " },
        { codigo: "26244", label: "UNIVERSIDADE FED. DO RIO GRANDE DO SUL " },
        { codigo: "26245", label: "UNIVERSIDADE FEDERAL DO RIO DE JANEIRO " },
        { codigo: "26246", label: "UNIVERSIDADE FEDERAL DE SANTA CATARINA " },
        { codigo: "26247", label: "UNIVERSIDADE FEDERAL DE SANTA MARIA " },
        { codigo: "26248", label: "UNIVERSIDADE FEDERAL RURAL DE PERNAMBUC " },
        { codigo: "26249", label: "UNIV. FEDERAL RURAL DO RIO DE JANEIRO " },
        { codigo: "26250", label: "UNIVERSIDADE FEDERAL DE RORAIMA " },
        { codigo: "26251", label: "FUNDACAO UNIVERSIDADE FED. DO TOCANTINS " },
        { codigo: "26252", label: "UNIVERSIDADE FEDERAL DE CAMPINA GRANDE " },
        { codigo: "26253", label: "UNIVERSIDADE FEDERAL RURAL DA AMAZONIA " },
        { codigo: "26254", label: "UNIVERSIDADE FED.DO TRIANGULO MINEIRO " },
        { codigo: "26255", label: "UNI.FED.VALES DO JEQUITINHONHA E MUCURI " },
        { codigo: "26256", label: "CENTRO FED.EDUC.TECNOL.CELSO S. FONSECA " },
        { codigo: "26257", label: "CENTRO FED.DE EDUC.TECNOL.MINAS GERAIS " },
        { codigo: "26258", label: "UNIVERS. TECNOLOGICA FEDERAL DO PARANA " },
        { codigo: "26259", label: "CENTRO DE EDUC. TECNOLOGICA DA BAHIA " },
        { codigo: "26260", label: "UNIVERSIDADE FEDERAL DE ALFENAS " },
        { codigo: "26261", label: "UNIVERSIDADE FEDERAL DE ITAJUBA " },
        { codigo: "26262", label: "UNIVERSIDADE FEDERAL DE SAO PAULO " },
        { codigo: "26263", label: "UNIVERSIDADE FEDERAL DE LAVRAS " },
        { codigo: "26264", label: "UNIVERSIDADE FED. RURAL DO SEMI-ARIDO " },
        { codigo: "26266", label: "FUNDACAO UNIVERSIDADE FEDERAL DO PAMPA " },
        { codigo: "26267", label: "UNIV.FED. DA INTEGRACAO LATINO-AMERICAN " },
        { codigo: "26268", label: "FUND. UNIVERSIDADE FEDERAL DE RONDONIA " },
        { codigo: "26269", label: "UNIVERSIDADE DO RIO DE JANEIRO " },
        { codigo: "26270", label: "FUNDACAO UNIVERSIDADE DO AMAZONAS " },
        { codigo: "26271", label: "FUNDACAO UNIVERSIDADE DE BRASILIA " },
        { codigo: "26272", label: "FUNDACAO UNIVERSIDADE DO MARANHAO " },
        { codigo: "26273", label: "UNIVERSIDADE FEDERAL DO RIO GRANDE " },
        { codigo: "26274", label: "FUNDACAO UNIV. FEDERAL DE UBERLANDIA " },
        { codigo: "26275", label: "UNIVERSIDADE FEDERAL DO ACRE " },
        { codigo: "26276", label: "UNIVERSIDADE FEDERAL DE MATO GROSSO " },
        { codigo: "26277", label: "FUNDACAO UNIV. FEDERAL DE OURO PRETO " },
        { codigo: "26278", label: "FUNDACAO UNIVERSIDADE FEDERAL DE PELOTA " },
        { codigo: "26279", label: "UNIVERSIDADE FEDERAL DO PIAUI " },
        { codigo: "26280", label: "UNIVERSIDADE FEDERAL DE SAO CARLOS " },
        { codigo: "26281", label: "FUNDACAO UNIVERSIDADE FEDERAL DE SERGIP " },
        { codigo: "26282", label: "UNIVERSIDADE FEDERAL DE VICOSA " },
        { codigo: "26283", label: "UNIV. FEDERAL DE MATO GROSSO DO SUL " },
        { codigo: "26284", label: "FUND.UNIV.FED.CIENC.SAUDE D PORTO ALEGR " },
        { codigo: "26285", label: "FUND. UNIVERSIDADE DE SAO JOAO DEL REI " },
        { codigo: "26286", label: "FUNDACAO UNVERSIDADE FEDERAL DO AMAPA " },
        { codigo: "26287", label: "ESCOLA AGROTECNICA FEDERAL DE MARABA " },
        { codigo: "26292", label: "FUNDACAO JOAQUIM NABUCO " },
        { codigo: "26293", label: "FUNDACAO ROQUETE PINTO " },
        { codigo: "26295", label: "INSTITUTO NACIONAL DE DESENV.DO DESPORT " },
        { codigo: "26296", label: "FUNDACAO EDUCAR " },
        { codigo: "26297", label: "FUNDACAO DE ASSISTENCIA AO ESTUDANTE " },
        { codigo: "26298", label: "FUND COORD APERF PESSOAL NIVEL SUPERIOR " },
        { codigo: "26300", label: "ESCOLA AGROTECNICA FEDERAL DE SATUBA " },
        { codigo: "26301", label: "ESCOLA AGROTECNICA FEDERAL DE MANAUS " },
        { codigo: "26302", label: "ESCOLA AGROTECNICA FEDERAL DE CATU " },
        { codigo: "26303", label: "ESCOLA AGROTECNICA FEDERAL DE CRATO " },
        { codigo: "26304", label: "ESCOLA AGROTECNICA FEDERAL DE IGUATU " },
        { codigo: "26305", label: "ESCOLA AGROTECNICA FEDERAL DE ALEGRE " },
        { codigo: "26306", label: "CENTRO FEDERAL DE EDUC TECNOL RIO VERDE " },
        { codigo: "26307", label: "ESCOLA AGROTECNICA FEDERAL DE SAO LUIS " },
        { codigo: "26308", label: "CENTRO FED. DE EDUC. TECNOL. DE BAMBUI " },
        { codigo: "26309", label: "ESCOLA AGROTECNICA FEDERAL DE BARBACENA " },
        { codigo: "26310", label: "CENTRO FED. DE EDUC.TECNOL. DE JANUARIA " },
        { codigo: "26311", label: "ESCOLA AGROTECNICA FEDERAL DE MUZAMBINH " },
        { codigo: "26312", label: "CENTRO FED. DE  EDUC.TECNOL.DE RIO POMB " },
        { codigo: "26313", label: "CENTRO FEDERAL EDUC.TECNOL.DE UBERABA " },
        { codigo: "26314", label: "ESCOLA AGROTECNICA FEDERAL DE UBERLANDI " },
        { codigo: "26315", label: "ESCOLA AGROTECNICA FEDERAL DE CASTANHAL " },
        { codigo: "26316", label: "ESCOLA AGROTECNICA FEDERAL DE SOUSA " },
        { codigo: "26317", label: "ESCOLA AGROTECNICA FEDERAL DE BARREIROS " },
        { codigo: "26318", label: "ESCOLA AGROTECNICA FED. DE BELO JARDIM " },
        { codigo: "26319", label: "ESCOLA AGROT.FED. DE VIT. DE S. ANTAO " },
        { codigo: "26320", label: "ESCOLA AGROTECNICA FED. DE SAO CRISTOVA " },
        { codigo: "26321", label: "CENTRO FED EDUC TEC.DE BENTO GONCALVES " },
        { codigo: "26322", label: "ESCOLA AGROTECNICA FEDERAL DE CONCORDIA " },
        { codigo: "26323", label: "ESCOLA AGROTECNICA FEDERAL DE SERTAO " },
        { codigo: "26324", label: "ESCOLA AGROTECNICA FEDERAL DE COLATINA " },
        { codigo: "26325", label: "CENTRO FEDERAL DE EDUC.TECNOL.DE URUTAI " },
        { codigo: "26326", label: "CENTRO FEDERAL DE EDUC.TECNOL. DE CUIAB " },
        { codigo: "26327", label: "ESCOLA AGROTECNICA FED. DE INCONFIDENTE " },
        { codigo: "26328", label: "ESCOLA AGROTECNICA FEDERAL DE MACHADO " },
        { codigo: "26329", label: "ESCOLA AGROTECNICA FEDERAL DE SALINAS " },
        { codigo: "26330", label: "ESCOLA AGROT. FED. DE S.J. EVANGELISTA " },
        { codigo: "26331", label: "ESCOLA AGROTECNICA FED. DE ARAGUATINS " },
        { codigo: "26332", label: "ESCOLA AGROTECNICA FEDERAL DE CACERES " },
        { codigo: "26333", label: "ESCOLA AGROTECNICA FEDERAL DE ALEGRETE " },
        { codigo: "26335", label: "ESCOLA AGROTECNICA FED. DE STA. TERESA " },
        { codigo: "26336", label: "CENTRO FED. DE ED. TEC. DE PETROLINA " },
        { codigo: "26337", label: "ESCOLA AGROTECNICA FEDERAL DE CERES " },
        { codigo: "26338", label: "CENTRO FED. EDUC.TEC. S VICENTE DO SUL " },
        { codigo: "26339", label: "ESCOLA AGROT.FED.COLORADO DO OESTE " },
        { codigo: "26340", label: "ESCOLA AGROT.FED.S.GABRIEL DA CACHOEIRA " },
        { codigo: "26341", label: "ESCOLA AGROTECNICA FEDERAL DE SOMBRIO " },
        { codigo: "26342", label: "ESCOLA AGROTECNICA FEDERAL DE RIO DO SU " },
        { codigo: "26343", label: "ESCOLA AGROTEC.FED.ANTONIO JOSE TEIXEIR " },
        { codigo: "26344", label: "ESCOLA AGROTEC. FEDERAL DE SANTA INES/B " },
        { codigo: "26345", label: "ESCOLA AGROTECNICA FEDERAL DE CODO/MA " },
        { codigo: "26346", label: "ESCOLA AGROT.FEDERAL SENHOR DO BONFIM/B " },
        { codigo: "26350", label: "FUND. UNIV FEDERAL DA GRANDE DOURADOS " },
        { codigo: "26351", label: "UNIV. FEDERAL DO RECONCAVO DA BAHIA " },
        { codigo: "26352", label: "FUNDACAO UNIVERSIDADE FEDERAL DO ABC " },
        { codigo: "26353", label: "ESCOLA TECNICA FEDERAL DO ACRE " },
        { codigo: "26354", label: "ESCOLA TECNICA FEDERAL DO AMAPA " },
        { codigo: "26356", label: "INST. FED. ED. CIENCIA E TEC.DE BRASILI " },
        { codigo: "26357", label: "ESCOLA TECNICA FEDERAL DE CANOAS " },
        { codigo: "26401", label: "INSTITUTO FEDERAL DO ACRE " },
        { codigo: "26402", label: "INSTITUTO FEDERAL DE ALAGOAS " },
        { codigo: "26403", label: "INSTITUTO FEDERAL DO AMAZONAS " },
        { codigo: "26404", label: "INSTITUTO FEDERAL BAIANO " },
        { codigo: "26405", label: "INSTITUTO FEDERAL DO CEARA " },
        { codigo: "26406", label: "INSTITUTO FEDERAL DO ESPIRITO SANTO " },
        { codigo: "26407", label: "INSTITUTO FEDERAL GOIANO " },
        { codigo: "26408", label: "INSTITUTO FEDERAL DO MARANHAO " },
        { codigo: "26409", label: "INSTITUTO FEDERAL DE MINAS GERAIS " },
        { codigo: "26410", label: "INSTITUTO FED. DO NORTE DE MINAS GERAIS " },
        { codigo: "26411", label: "INSTITUTO FED.DO SUDESTE DE MINAS GERAI " },
        { codigo: "26412", label: "INSTITUTO FEDERAL DO SUL DE MINAS GERAI " },
        { codigo: "26413", label: "INSTITUTO FEDERAL DO TRIANGULO MINEIRO " },
        { codigo: "26414", label: "INSTITUTO FEDERAL DE MATO GROSSO " },
        { codigo: "26415", label: "INSTITUTO FEDERAL DE MATO GROSSO DO SUL " },
        { codigo: "26416", label: "INSTITUTO FEDERAL DO PARA " },
        { codigo: "26417", label: "INSTITUTO FEDERAL DA PARAIBA " },
        { codigo: "26418", label: "INSTITUTO FEDERAL DE PERNAMBUCO " },
        { codigo: "26419", label: "INSTITUTO FEDERAL DO RIO GRANDE DO SUL " },
        { codigo: "26420", label: "INSTITUTO FEDERAL FARROUPILHA " },
        { codigo: "26421", label: "INSTITUTO FEDERAL DE RONDONIA " },
        { codigo: "26422", label: "INSTITUTO FEDERAL CATARINENSE " },
        { codigo: "26423", label: "INSTITUTO FEDERAL DE SERGIPE " },
        { codigo: "26424", label: "INSTITUTO FEDERAL DO TOCANTINS " },
        { codigo: "26426", label: "INSTITUTO FEDERAL DO AMAPA " },
        { codigo: "26427", label: "INSTITUTO FEDERAL DA BAHIA " },
        { codigo: "26428", label: "INSTITUTO FEDERAL DE BRASILIA " },
        { codigo: "26429", label: "INSTITUTO FEDERAL DE GOIAS " },
        { codigo: "26430", label: "INSTITUTO FEDERAL DO SERTAO PERNAMBUCAN " },
        { codigo: "26431", label: "INSTITUTO FEDERAL DO PIAUI " },
        { codigo: "26432", label: "INSTITUTO FEDERAL DO PARANA " },
        { codigo: "26433", label: "INSTITUTO FEDERAL DO RIO DE JANEIRO " },
        { codigo: "26434", label: "INSTITUTO FEDERAL FLUMINENSE " },
        { codigo: "26435", label: "INSTITUTO FEDERAL DO RIO GRANDE DO NORT " },
        { codigo: "26436", label: "INSTITUTO FEDERAL SUL RIO-GRANDENSE " },
        { codigo: "26437", label: "INSTITUTO FEDERAL DE RORAIMA " },
        { codigo: "26438", label: "INSTITUTO FEDERAL DE SANTA CATARINA " },
        { codigo: "26439", label: "INSTITUTO FEDERAL DE SAO PAULO " },
        { codigo: "26440", label: "UNIVERSIDADE FEDERAL DA FRONTEIRA SUL " },
        { codigo: "26441", label: "UNIVERSIDADE FEDERAL DO OESTE DO PARA " },
        { codigo: "26442", label: "UN. INT.INTERN. LUSOFONIA AFROBRASILEIR " },
        { codigo: "26443", label: "EMPRESA BRAS. DE SERVICOS HOSPITALARES " },
        { codigo: "26447", label: "UNIVERSIDADE FEDERAL DO OESTE DA BAHIA " },
        { codigo: "26448", label: "UNIVERSIDADE FED. SUL SUDESTE DO PARA " },
        { codigo: "26449", label: "UNIVERSIDADE FEDERAL DO CARIRI " },
        { codigo: "26450", label: "UNIVERSIDADE FEDERAL DO SUL DA BAHIA " },
        { codigo: "27000", label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: "28000", label: "MINISTERIO IND. COM. EXTERIOR E SERVI§O " },
        { codigo: "29000", label: "MINISTERIO DO ESPORTE " },
        { codigo: "29202", label: "SUP.DE DESENVOLVIMENTO DO CENTRO OESTE " },
        { codigo: "29203", label: "EMPRESA BRAS. DE PLANEJ. DE TRANSPORTES " },
        { codigo: "29205", label: "EMPRESA DE TRENS URBANOS DE PORTO ALEGR " },
        { codigo: "29214", label: "COMPANHIA BRASILEIRA DE TRENS URBANOS " },
        { codigo: "30102", label: "IMPRENSA NACIONAL " },
        { codigo: "30202", label: "FUNDACAO NACIONAL DO INDIO " },
        { codigo: "30203", label: "INST.NAC.METROLOGIA,NORM.E QUAL.INDL. " },
        { codigo: "30204", label: "INSTITUTO NAC. DA PROPRIEDADE INDUSTRIA " },
        { codigo: "30802", label: "DEPTO. DE POLICIA RODOVIARIA FEDERAL " },
        { codigo: "31000", label: "MINIST. ECONOMIA, FAZENDA E PLANEJAMENT " },
        { codigo: "31203", label: "INSTITUTO BRASILEIRO DO CAFE " },
        { codigo: "32000", label: "MINISTERIO DE MINAS E ENERGIA " },
        { codigo: "32100", label: "DEPARTAMENTO NAC. DE PRODUCAO MINERAL " },
        { codigo: "32200", label: "AGENCIA NACIONAL DE ENERGIA ELETRICA " },
        { codigo: "32300", label: "AGENCIA NAC PETROLEO GAS NAT BIOCOMBUST " },
        { codigo: "32314", label: "EMPRESA DE PESQUISA ENERGETICA " },
        { codigo: "32396", label: "AGENCIA NACIONAL DE MINERACAO " },
        { codigo: "33206", label: "SUPERINT.NAC.DE PREVIDENCIA COMPLEMENTA " },
        { codigo: "34000", label: "SECRETARIA DA CULTURA / PR " },
        { codigo: "35000", label: "MINISTERIO DAS RELACOES EXTERIORES " },
        { codigo: "35201", label: "FUNDACAO ALEXANDRE DE GUSMAO " },
        { codigo: "36102", label: "FUNDACAO NACIONAL DE SAUDE " },
        { codigo: "36103", label: "CENTRAL DE MEDICAMENTOS " },
        { codigo: "36201", label: "FUNDACAO OSWALDO CRUZ " },
        { codigo: "36203", label: "INST. NACIONAL DE ALIMENTACAO E NUTRICA " },
        { codigo: "36204", label: "FUNDACAO DAS PIONEIRAS SOCIAIS " },
        { codigo: "36205", label: "FUNDACAO NACIONAL DE SAUDE " },
        { codigo: "36206", label: "EX-INST. NAC.DE ASS. MED. DA PREV.SOCIA " },
        { codigo: "36207", label: "AGENCIA NACIONAL DE VIGILANCIA SANITARI " },
        { codigo: "36208", label: "AGENCIA NACIONAL DE SAUDE SUPLEMENTAR " },
        { codigo: "36209", label: "HOSPITAL FEMINA " },
        { codigo: "36210", label: "HOSPITAL NOSSA SENHORA DA CONCEICAO " },
        { codigo: "36211", label: "HOSPITAL CRISTO REDENTOR " },
        { codigo: "37000", label: "DEFENSORIA PUBLICA DA UNIAO " },
        { codigo: "38000", label: "CONSELHO ADMINIST.DE DEFESA ECONOMICA " },
        { codigo: "39250", label: "AGENCIA NAC. DE TRANSPORTES TERRESTRES " },
        { codigo: "39251", label: "AGENCIA NAC. DE TRANSPORTES AQUAVIARIOS " },
        { codigo: "39252", label: "DEPARTAMENTO NAC.DE INFRAEST. DE TRANSP " },
        { codigo: "39253", label: "EMPRESA DE PLANEJAMENTO E LOGISTICA S.A " },
        { codigo: "40000", label: "CENTRAL DE ATENDIMENTO DRH/SAF/PR " },
        { codigo: "40103", label: "MINIST.DA ADM.FEDERAL E REF. DO ESTADO " },
        { codigo: "40105", label: "MINISTERIO DA DEFESA " },
        { codigo: "40106", label: "ADVOCACIA-GERAL DA UNIAO " },
        { codigo: "40107", label: "MINISTERIO DA CULTURA " },
        { codigo: "40108", label: "MINIST»RIO CI¼NCIA TEC.INOV.COMUNICA¸ùE " },
        { codigo: "40109", label: "EX-MINISTERIO DA INTEGRACAO REGIONAL " },
        { codigo: "40110", label: "SECRETARIA DE DESPORTOS / PR " },
        { codigo: "40111", label: "MINISTERIO DO MEIO AMBIENTE " },
        { codigo: "40112", label: "MINISTERIO DO DESENVOLVIMENTO REGIONAL " },
        { codigo: "40202", label: "FUNDACAO ESCOLA NACIONAL DE ADM. PUBLIC " },
        { codigo: "40301", label: "COMISSAO NACIONAL DE ENERGIA NUCLEAR " },
        { codigo: "40403", label: "FUNDACAO CASA DE RUI BARBOSA " },
        { codigo: "40408", label: "FUNDACAO CULTURAL PALMARES " },
        { codigo: "40501", label: "CONSELHO NAC.DE DESEN.CIEN.E TECNOLOGIC " },
        { codigo: "40503", label: "FUNDACAO CENTRO TECNOL. PARA INFORMATIC " },
        { codigo: "40601", label: "SUPERINT. DO DESENVOLVIMENTO DO NORDEST " },
        { codigo: "40602", label: "SUPERINTENDENCIA DO DESENV. DA AMAZONIA " },
        { codigo: "40603", label: "SUPERINTENDENCIA ZONA FRANCA DE MANAUS " },
        { codigo: "40604", label: "INSTITUTO BRASILEIRO DE TURISMO " },
        { codigo: "40701", label: "INST. BR. MEIO AMB. REC. NAT. RENOVAVEI " },
        { codigo: "40801", label: "GOVERNO DO EX-TERRITORIO DO AMAPA " },
        { codigo: "40802", label: "GOVERNO DO EX-TERRITORIO DO ACRE " },
        { codigo: "40803", label: "GOVERNO DO EX-TERRITORIO DE RONDONIA " },
        { codigo: "40804", label: "GOVERNO DO EX-TERRITORIO DE RORAIMA " },
        { codigo: "40805", label: "ANTIGO EST.GUANABARA E DISTRITO FEDERAL " },
        { codigo: "40806", label: "DEP.DE CENTRAL.SERV.DE INATIVOS E PENS. " },
        { codigo: "41000", label: "MINISTERIO DAS COMUNICACOES " },
        { codigo: "41200", label: "EMPRESA BRASILEIRA DE COMUNICACAO S.A. " },
        { codigo: "41231", label: "AGENCIA NACIONAL DE TELECOMUNICACOES " },
        { codigo: "42000", label: "MINISTERIO DO DESENVOLVIMENTO AGRARIO " },
        { codigo: "42102", label: "COMISSAO EXEC. PLANO LAVOURA CACAUEIRA " },
        { codigo: "42201", label: "INSTITUTO NAC. DE COLONIZ E REF AGRARIA " },
        { codigo: "42204", label: "DEPTO. NACIONAL DE OBRAS CONTRA AS SECA " },
        { codigo: "42207", label: "INSTITUTO BRASILEIRO DE MUSEUS " },
        { codigo: "43000", label: "EX-MINISTERIO DO BEM-ESTAR SOCIAL " },
        { codigo: "43201", label: "EX-FUND.CENTRO BRAS. P.INFANC./ADOLESC " },
        { codigo: "43202", label: "EX-FUNDACAO LEGIAO BRAS. DE ASSISTENCIA " },
        { codigo: "44205", label: "AGENCIA NACIONAL DE AGUAS " },
        { codigo: "44206", label: "INSTITUTO DE PESQ. JARDIM BOTANICO DO R " },
        { codigo: "44207", label: "INSTITUTO CHICO MENDES CONSERV.BIODIVER " },
        { codigo: "45203", label: "COMISSAO DE VALORES MOBILIARIOS " },
        { codigo: "45205", label: "FUND. INST. BRASIL. GEOG. E ESTATISTICA " },
        { codigo: "45206", label: "INSTITUTO DE PESQUISA ECONOMICA APLICAD " },
        { codigo: "45208", label: "SUPERINTENDENCIA DE SEGUROS PRIVADOS " },
        { codigo: "46000", label: "MICT " },
        { codigo: "49000", label: "MINISTERIO DA INFRAESTRUTURA " },
        { codigo: "49201", label: "DEPARTAMENTO NAC. DE ESTRADAS DE RODAGE " },
        { codigo: "49300", label: "VALEC ENG.CONSTRUCOES E FERROVIAS S/A " },
        { codigo: "51000", label: "AUTORIDADE.DE GOVER.DO LEGADO OLIMPICO " },
        { codigo: "52201", label: "AGENCIA NACIONAL DE AVIACAO CIVIL " },
        { codigo: "52233", label: "AMAZONIA AZUL TECNOLOGIAS DE DEFESA SA " },
        { codigo: "53202", label: "SUPERINTENDENCIA DO DESENV. DA AMAZONIA " },
        { codigo: "53203", label: "SUPERINTENDENCIA DO DESENV. DO NORDESTE " },
        { codigo: "53205", label: "AGENCIA DE DESENVOLVIMENTO DA AMAZONIA " },
        { codigo: "53206", label: "AGENCIA DE DESENVOLVIMENTO DO NORDESTE " },
        { codigo: "53297", label: "SUP.DE DESENVOLVIMENTO DO CENTRO OESTE " },
        { codigo: "54000", label: "MINISTERIO DO TURISMO " },
        { codigo: "55000", label: "MINISTERIO DA CIDADANIA " },
        { codigo: "56000", label: "MINISTERIO DAS CIDADES " },
        { codigo: "57201", label: "FUND.JORGE DUPRAT FIG. SEG. MED.TRABALH " },
        { codigo: "57202", label: "INSTITUTO NACIONAL DE SEGURO SOCIAL " },
        { codigo: "57203", label: "EMPR.DE PROCESS.DE DADOS DA PREV.SOCIAL " },
        { codigo: "58000", label: "MINISTERIO DE PESCA E AQUICULTURA " },
        { codigo: "59000", label: "CONTROLADORIA-GERAL DA UNIAO " },
        { codigo: "70000", label: "COMANDO DA MARINHA " },
        { codigo: "70101", label: "MINISTERIO DA MARINHA II " },
        { codigo: "70102", label: "TRIBUNAL MARITIMO " },
        { codigo: "77000", label: "FUND PREV COMPL SERV PUBL FED EXECUTIVO " },
        { codigo: "80101", label: "INST.DE PREV.SOC. DO SERVIDOR PUBLICO " },
        { codigo: "80202", label: "SUPERINTENDENCIA DO DES. DA REGIAO SUL " },
        { codigo: "80203", label: "DEPART. NAC. DE O. DE SANEAMENTO ( EXT. " },
        { codigo: "80204", label: "INSTITUTO DO ACUCAR E DO ALCOOL " },
        { codigo: "81000", label: "MIN. DA MULHER, FAMILIA E DIR. HUMANOS " },
        { codigo: "90150", label: "MINISTERIO PUBLICO DA UNIAO " },
        { codigo: "91214", label: "AUTORIDADE PUBLICA OLIMPICA " },
        { codigo: "99007", label: "COMPANHIA DE NAVEGACAO DO SAO FRANCISCO " },
        { codigo: "99009", label: "EMPRESA DE NAVEGACAO DA AMAZONIA " },
        { codigo: "99010", label: "COMPANHIA DE PESQUISA DE REC. MINERAIS " },
        { codigo: "99013", label: "HOSPITAL DE CLINICAS DE PORTO ALEGRE " },
        { codigo: "99016", label: "SENADO FEDERAL " },
        { codigo: "99072", label: "GOVERNO DO DISTRITO FEDERAL " },
        { codigo: "99074", label: "GOVERNO DO DISTRITO FEDERAL " },
        { codigo: "99901", label: "CONSELHO DE JUSTICA FEDERAL " },
        { codigo: "99991", label: "ESTADOS / MUNICIPIOS / EMPRESAS " }
      ]

  }
  modalLivroCaixa() {
    console.log(this.grupo);
    let Modal = this.modalCtrl.create(ModalLivroCaixaPage, { siape: this.usuario.siape, grupo: this.grupo });
    Modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    Modal.present();
  }
  buscarBancos() {
    this._http
      .get(config.urlAPI + "listar/bancos", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.bancos = res;
      }).catch(err => {
        console.log(err)

      })
  }
  voltar() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/perfil/perfil.ts